module.exports = __webpack_public_path__ + "static/media/arduino.eb7d9054.png";